"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _Spinner = _interopRequireDefault(require("@concur/nui-widgets/lib/Spinner/Spinner"));
var _ConnectedMessage = _interopRequireDefault(require("./sharedComponents/ConnectedMessage"));
var _analytics = require("../../../../constants/analytics");
var _AutoConnectInput = _interopRequireDefault(require("../../../AutoConnectInput"));
var _styles = require("../../styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function AutoconflowConnectionSection(_ref) {
  var listing = _ref.listing,
    isDisabled = _ref.isDisabled,
    trackLinkClick = _ref.trackLinkClick,
    companyUUID = _ref.companyUUID,
    trackButtonClick = _ref.trackButtonClick,
    launchTermsAndConditionsModal = _ref.launchTermsAndConditionsModal,
    connectToListing = _ref.connectToListing,
    terms = _ref.terms,
    isConnecting = _ref.isConnecting,
    onConnectButtonClick = _ref.onConnectButtonClick,
    onDisconnectButtonClick = _ref.onDisconnectButtonClick;
  var ID = listing.ID,
    _listing$core = listing.core,
    oAuthWorkflowType = _listing$core.oAuthWorkflowType,
    isConnectionPending = _listing$core.isConnectionPending,
    isUserConnected = _listing$core.isUserConnected,
    listingName = _listing$core.listingName,
    v1ID = _listing$core.v1ID,
    supportNewEnrollment = _listing$core.supportNewEnrollment,
    triplinkLoyaltyNumber = _listing$core.triplinkLoyaltyNumber,
    canUserConnect = _listing$core.canUserConnect,
    loyaltyNumber = listing.loyaltyNumber;
  var _ref2 = terms || {},
    previouslyAccepted = _ref2.previouslyAccepted,
    currentlyAccepted = _ref2.currentlyAccepted;

  // This is the launchTaC function inside the showNeedAnAccountLink function
  function onNeedAnAccountClickWithNoTerms(event) {
    trackLinkClick({
      elementPath: ["".concat(_analytics.listingConst, " ").concat(listingName), _analytics.connectLoyaltyNumber, _analytics.needAnAccountLink, _analytics.launchTAndC],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    trackButtonClick({
      elementPath: ["".concat(_analytics.listingConst, " ").concat(listingName), _analytics.button.connect],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    launchTermsAndConditionsModal({
      tAndCLinkClicked: false,
      flow: oAuthWorkflowType,
      listingId: listing.ID,
      v1ListingId: v1ID,
      needAnAccountClicked: true
    });
    event.preventDefault();
  }

  // This is the connectWithoutTaC function inside the showNeedAnAccountLink function
  function onNeedAnAccountClickWithTerms(event) {
    trackLinkClick({
      elementPath: ["".concat(_analytics.listingConst, " ").concat(listingName), _analytics.connectLoyaltyNumber, _analytics.needAnAccountLink, _analytics.connectWithoutTAndC],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    event.preventDefault();
    connectToListing(ID, v1ID, {
      needAnAccountClicked: true
    });
  }
  var areTermsAccepted = previouslyAccepted || currentlyAccepted;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isConnectionPending && !isUserConnected && /*#__PURE__*/_react.default.createElement(_AutoConnectInput.default, {
    listing: listing,
    isDisabled: isDisabled
  }), isUserConnected && /*#__PURE__*/_react.default.createElement(_ConnectedMessage.default, null), !isConnectionPending && !isUserConnected && !isDisabled && supportNewEnrollment && !triplinkLoyaltyNumber && /*#__PURE__*/_react.default.createElement("p", {
    style: {
      textAlign: 'center',
      paddingBottom: '5px'
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "link",
    onClick: areTermsAccepted ? onNeedAnAccountClickWithTerms : onNeedAnAccountClickWithNoTerms
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "NeedAnAccount"
  }))), isConnectionPending && !isUserConnected && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "ConnectionPending"
  })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("h4", null, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "ConnectionPendingMessage"
  }))), !isConnectionPending && !isUserConnected && canUserConnect && /*#__PURE__*/_react.default.createElement(_Button.default, {
    id: "listing-appcenter-flow-connect-button",
    onClick: onConnectButtonClick,
    style: _styles.BUTTON_STYLE,
    innerProps: {
      className: 'max-button-width'
    },
    disabled: isDisabled || isConnecting || !loyaltyNumber && !triplinkLoyaltyNumber
  }, isConnecting ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    size: "lg",
    type: "inline",
    className: "spinner",
    visible: isConnecting,
    message: ""
  }) : /*#__PURE__*/_react.default.createElement("span", {
    style: isDisabled ? {
      fontStyle: 'italic'
    } : {}
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Connect"
  }))), isUserConnected && /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onDisconnectButtonClick,
    style: _styles.BUTTON_STYLE,
    innerProps: {
      className: 'max-button-width'
    }
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Disconnect"
  })));
}
AutoconflowConnectionSection.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string.isRequired,
    core: _propTypes.default.shape({
      isConnectionPending: _propTypes.default.bool.isRequired,
      isUserConnected: _propTypes.default.bool.isRequired,
      listingName: _propTypes.default.string.isRequired,
      oAuthWorkflowType: _propTypes.default.string.isRequired,
      v1ID: _propTypes.default.string.isRequired,
      supportNewEnrollment: _propTypes.default.bool.isRequired,
      triplinkLoyaltyNumber: _propTypes.default.number,
      canUserConnect: _propTypes.default.bool
    }).isRequired,
    loyaltyNumber: _propTypes.default.string
  }).isRequired,
  isDisabled: _propTypes.default.bool,
  trackLinkClick: _propTypes.default.func.isRequired,
  companyUUID: _propTypes.default.string.isRequired,
  trackButtonClick: _propTypes.default.func.isRequired,
  terms: _propTypes.default.shape({
    currentlyAccepted: _propTypes.default.bool,
    previouslyAccepted: _propTypes.default.bool
  }).isRequired,
  launchTermsAndConditionsModal: _propTypes.default.string.isRequired,
  connectToListing: _propTypes.default.string.isRequired,
  isConnecting: _propTypes.default.bool,
  onConnectButtonClick: _propTypes.default.func.isRequired,
  onDisconnectButtonClick: _propTypes.default.func.isRequired
};
var _default = exports.default = AutoconflowConnectionSection;